import angular from 'angular';
import 'angular-legacy-sortablejs-maintained';

import TeamListComponent from './team-list.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-navigation.component.team-list', [
        'ng-sortable'
    ])
    .component(TeamListComponent.selector, TeamListComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/component/team-list/index.js